var filterValues = '';
var resultsSortOrder = 'default';
var resultsPage = 1;

function apartmentsSearchRequest(filterValues, resultsSortOrder, resultsPage = 1) {

    // var filtersValues = ( intFilterValues ) ? intFilterValues : filterValues;
    // var sortOrder = ( intResultsSortOrder ) ? intResultsSortOrder : resultsSortOrder;
    // var paged = ( intResultsPage ) ? intResultsPage : resultsPage;
    
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('input[name="_token"]').val()
        }
     });
     $.ajax({
         url: "/api/developments",
         method: 'POST',
         data: {
            filterValues: filterValues,
            resultsSortOrder: resultsSortOrder,
            resultsPage: resultsPage,
         },
         success: function(result){

            if( result.output ) {
                $('#no-results-container').hide();
                $('#appartment-search-results-container').addClass('show');
                $('#appartment-search-results-container #appartment-search-results').html(result.output);
                $('#apt-loader').hide();
            } else {
                $('#appartment-search-results-container #appartment-search-results').html(''); // Clear results
                $('#apt-loader').hide(); // hide loader
                $('#no-results-container').show(); // Show no results message
            }
             
             
             // scroll to results
             var headerHeight = $('#main-navigation').outerHeight();
             var searchContainerPos = $('#appartment-search-results-container').offset().top;
             $('html, body').animate({
                scrollTop: searchContainerPos-headerHeight
           }, 600);
         },
         error: function(data) {
             //var responseText=JSON.parse(data.responseText);

             $('#development-grid-heading').show();
             $('#development-grid-footer').show();
             $('#development-grid').show();
             $('#appartment-search-results-container').removeClass('show');
         }
     });
}

$(function() {

    var $aptSearch = $('#development-search');
    var $aptSearchResults = $('#appartment-search-results-container');
    var $devHeadng = $('#development-grid-heading');
    var $devGrid = $('#development-grid');

    if( $aptSearchResults.length ) {

        $aptSearchResults.on('click', '.show-appartment-features-js', function () {
            $(this).closest('.development-grid-item').toggleClass("is-active");
        });
    }

    $('#development-search-form').on('submit', function(e){
        e.preventDefault();
        $('#apt-loader').show();
        $('#development-grid-heading').hide();
        $('#development-grid-footer').hide();
        $('#development-grid').hide();

        let formFieldData = $(this).serializeArray();

        // Ajax request
        filterValues = JSON.stringify(formFieldData); // set filters values globally
        apartmentsSearchRequest(filterValues, resultsSortOrder, 1);
    });

    // Clear Form
    $('#clear-form').on('click', function(e){
        $('#development-search-form select').val('all').trigger('change');
        $('#development-search-form button[type="submit"]').trigger('click');
    });

    // Pagination 
    $aptSearchResults.on('click', '.pagination a.page-link', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('page=')[1];
        resultsPage = page; // update page
        apartmentsSearchRequest(filterValues, resultsSortOrder, resultsPage);
        
    });

    // Development sales status redirect
    var $apartmentSortFilter = $('#appartment-search-results-container .sort-filter select');
    if ( $apartmentSortFilter.length ) {
        // Select2 - Open
        $apartmentSortFilter.on("select2:open", function (e) { 
            // Remove default value
            //$(e.currentTarget).val('');
        });
        // Select2 - Item selected 
        $apartmentSortFilter.on("select2:select", function (e) { 
            var sortOrder = $(e.currentTarget).val();
            resultsSortOrder = sortOrder; // Set global results order
            apartmentsSearchRequest(filterValues, resultsSortOrder, 1);
            
            // var pageRedirect = $(e.currentTarget).data('redirect');
            // var devStatus = ( select_val == 'all') ? '' : '?devstatus='+select_val;
            // // redirect to page
            // window.location.replace(pageRedirect+devStatus);
        });
    }
});